import gsap from 'gsap'

// core version + navigation, pagination modules:
import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

function toggleGridDisplay(){
    const toggle = document.querySelector('[data-name="lightbox-toggle"]')
    if(toggle){
        const toggleHighlight = document.querySelector('[data-name="lightbox-toggle-highlight"]')
        const toggleMap = document.querySelector('[data-name="lightbox-map"]')
        const toggleGrid = document.querySelector('[data-name="lightbox-grid"]')
        toggle.addEventListener('click', function(){
            console.info('click')
            if(toggle.classList.contains('toggle-right')){
                toggle.classList.remove('toggle-right')
                gsap.to(toggleHighlight, {x: '0%'})
                gsap.set(toggleMap, {display: 'none'})
                gsap.set(toggleGrid, {display: 'block'})
            }else{
                console.info('no toggle right');
                toggle.classList.add('toggle-right')
                gsap.to(toggleHighlight, {x: '100%'})
                gsap.set(toggleGrid, {display: 'none'})
                gsap.set(toggleMap, {display: 'block'})
            }
        })
    }
}
function lightboxSlider() {


    
    // init Swiper:
    var init = false;

    // if (window.innerWidth >= 768) {
        if ( ! init ) {
            init = true;

            const swiper = new Swiper('.lightbox-slider', {

                modules: [Pagination, Autoplay, EffectFade, Navigation],
                loop: true,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
                spaceBetween: 0,
                speed: 1000,
            });
        }
    // } else if ( init ) {
        // swiper.destroy();

        // init = false;
    // }
}
// lightboxSlider();
toggleGridDisplay();
window.addEventListener("resize", lightboxSlider);

export default lightboxSlider;